// @react/hooks/useAffiliatePostback.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { affiliatePostbackStore } from '@core/stores';

/**
 * React hook for Postback operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAffiliatePostback } from '@react/hooks';
 *
 * const PostbackList = observer(() => {
 *   const store = useAffiliatePostback();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAffiliatePostback() {
  return affiliatePostbackStore;
}
